<template>
  <div class="container">
    <div class="row">
      <div class="col-sm-3 hidden-xs column-left" id="column-left">
        <div class="column-block">
          <div class="columnblock-title">Categories</div>
          <div class="category_block">
            <ul class="box-category treeview-list treeview">
              <li>
                <a href="#/category/electronics">Electronics</a>
              </li>
              <li>
                <a href="#/category/mobile">Mobile</a>
              </li>
              <li>
                <a href="#/category/fashion">Fashion</a>
              </li>
              <li>
                <a href="#/category/games">Games</a>
              </li>
              <li>
                <a href="#/category/sports">Sports</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-sm-9" id="content">
        <div class="row">
          <div class="col-sm-6">
            <div class="well">
              <h2>TAGGING</h2>
              <div class="form-group">
                <label for="input-contactkey" class="control-label">Tag Name</label>
                <input
                  type="text"
                  class="form-control"
                  id="input-contactkey"
                  placeholder
                  value
                  name
                  required
                  v-model="tagName"
                >
                <label for="input-contactkey" class="control-label">Tag Value</label>
                <input
                  type="text"
                  class="form-control"
                  id="input-contactkey"
                  placeholder
                  value
                  name
                  v-model="tagValue"
                >
                <label for="input-contactkey" class="control-label">Change Value</label>
                <input
                  type="text"
                  class="form-control"
                  id="input-contactkey"
                  placeholder
                  value
                  name
                  v-model="changeValue"
                >
                <label for="input-contactkey" class="control-label">Change Time</label>
                <input
                  type="datetime-local"
                  class="form-control"
                  id="input-contactkey"
                  placeholder
                  value
                  name
                  v-model="changeTime"
                >
                <label for="input-contactkey" class="control-label">Delete Time</label>
                <input
                  type="datetime-local"
                  class="form-control"
                  id="input-contactkey"
                  placeholder
                  value
                  name
                  v-model="deleteTime"
                >
              </div>
              <div style="display: grid">
                  <input type="submit" class="btn btn-primary" value="Create Tag" @click="createTag()">
                  <label v-if="message" style="color: red; margin-top:20px">{{ message }}</label>
                  <label v-if="succsesMsg" style="color: green; margin-top:20px">{{ succsesMsg }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tagName: "",
      tagValue: "",
      changeValue: "",
      changeTime: "",
      deleteTime: "",
      contactKey: "",
      deviceId: "",
      isShowButton: false,
      message: "",
      succsesMsg: ""
    };
  },
  methods: {
    createTag() {
      if (!this.tagName) {
        this.message = "Tag Name cannot be empty";
        return;
      }
      this.message = '';
      
      var tags = [
        {
          tag: this.tagName,
          Value: this.tagValue,
          changeValue: this.changeValue,
          changeTime: new Date(this.changeTime),
          removeTime: new Date(this.deleteTime)
        }
      ];
      console.log(JSON.stringify(tags));
      dengage("setTags", tags);
      this.succsesMsg = "Tag inserted successfully.";
      this.tagName="";
      this.tagValue= "";
      this.changeValue= "";
      this.changeTime= "";
      this.deleteTime= "";
    }, 
    async getSubscriptionText() {
      var sw = await navigator.serviceWorker.ready;
      var sub = await sw.pushManager.getSubscription();
      var subscriptionText = JSON.stringify(sub.toJSON());
      return subscriptionText;
    }
    
  }, 
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/Tagging.vue